import * as API from '../_api';
import GeoJSON from 'ol/format/GeoJSON';
import {Vector as VectorSource} from 'ol/source';
import {Fill, Icon, Stroke, Style} from 'ol/style';
import {Vector as VectorLayer} from 'ol/layer';
import Feature from 'ol/Feature';
import {Point} from 'ol/geom';
// @ts-ignore
import {saveAs} from 'file-saver';

// @ts-ignore
export const read = async ({commit, dispatch, state}) => {
  try {
    dispatch('common/loader/start', null, {root: true});
    const all = await API.read();
    state.all = all.data;
    dispatch('drawCatchments');
    dispatch('common/loader/stop', null, {root: true});
    return true;
  } catch (ex) {
    dispatch('common/loader/stop', null, {root: true});
    dispatch('common/snackbar/error', ex, {root: true});
    return false;
  }
};

// @ts-ignore
export const drawCatchments = async ({state, dispatch, rootState}) => {
  // TODO: remove all catchment layers
  if (!state.all || state.all.length <= 0) {
    return;
  }

  if (state.layers) {
    state.layers.forEach((layer: VectorLayer) => {
      rootState.map.map.removeLayer(layer);
    });
    state.layers = [];
    state.activeLayer = null;
  }

  // iterate through features and group them
  const catchmentGroups: any = {};

  const features = (new GeoJSON()).readFeatures(state.all);
  features.forEach((feature: any) => {
    if (!catchmentGroups[feature.get('id')]) {
      catchmentGroups[feature.get('id')] = [feature];
    } else {
      catchmentGroups[feature.get('id')].push(feature);
    }
  });

  const A_LIMIT_DEPENDING_FILLS: Array<[number, number, number, number]> = [
    [255, 0, 0, 0.2],
    [0, 255, 0, 0.2],
    [0, 0, 255, 0.2],
  ];
  const STROKE_COLOR: [number, number, number, number] = [0, 0, 255, 1];
  const fillColor = A_LIMIT_DEPENDING_FILLS[0];
  const strokeColor = STROKE_COLOR;

  Object.keys(catchmentGroups).forEach((i) => {
    catchmentGroups[i].sort((a: any, b: any) => {
      if (a.get('a_limit') < b.get('a_limit')) {
        return -1;
      }
      if (a.get('a_limit') > b.get('a_limit')) {
        return 1;
      }
      return 0;
    });

    const x = catchmentGroups[i][0].get('start_x');
    const y = catchmentGroups[i][0].get('start_y');

    const flag = new Feature({
      geometry: new Point([x, y]),
      name: 'Null Island',
      population: 4000,
      rainfall: 500,
    });

    const flagStyle = new Style({
      image: new Icon({
        imgSize: [56, 72],
        scale: 0.3,
        anchor: [0.0, 0.99],
        src: '/images/catchment-start-point.png',
      }),
    });

    flag.setStyle(flagStyle);
    catchmentGroups[i].push(flag);

    const source = new VectorSource({
      features: catchmentGroups[i],
    });

    const vLayer = new VectorLayer({
      source,
      style: (feature) => {
        return new Style({
          stroke: new Stroke({
            color: strokeColor,
            width: 3,
          }),
          fill: new Fill({
            color: A_LIMIT_DEPENDING_FILLS[catchmentGroups[i].indexOf(feature)],
          }),
          // adding an image here does not work, maybe add the layer and then do some hide/show tactic?
          image: new Icon({
            src: '/images/catchment-start-point.png',
            imgSize: [56, 72],
            scale: 0.3,
            anchor: [0.0, 0.99],
            crossOrigin: 'anonymous',
          }),
        });
      },
    });

    vLayer.set('name', catchmentGroups[i][0].get('name'));
    vLayer.set('created_at', catchmentGroups[i][0].get('created_at'));
    vLayer.set('unit', catchmentGroups[i][0].get('unit'));
    vLayer.set('limits',
      `${catchmentGroups[i][0].get('a_limit')},` +
      `${catchmentGroups[i][1].get('a_limit')},` +
      `${catchmentGroups[i][2].get('a_limit')}`);


    state.layers.forEach((layer: VectorLayer) => {
      layer.setVisible(false);
    });

    state.activeLayer = vLayer;
    state.layers.push(vLayer);

    dispatch('map/addLayer', vLayer, {root: true});
    dispatch('map/centerOn', source, {root: true});
  });
};

// @ts-ignore
export const selectLayer = async ({state, dispatch}, vLayer) => {
  state.activeLayer = vLayer;

  state.layers.forEach((layer: VectorLayer) => {
    layer.setVisible(false);
  });

  state.activeLayer.setVisible(true);

  state.ageMicroraster = null;
  state.buyingPowerMicroraster = null;
  state.competitors = null;
  state.microraster = null;

  dispatch('map/centerOn', state.activeLayer.getSource(), {root: true});
};

// @ts-ignore
export const setVisibility = async ({state, dispatch}, visibility) => {
  state.activeLayer.setVisible(visibility);
};

// @ts-ignore
export const getStatistics = async ({state, dispatch, rootState}, layer) => {
  dispatch('common/loader/start', null, {root: true});

  const specialty = rootState.doctors.hauptfach;

  state.ageMicroraster = (await API.getAgeMicroraster(layer)).data;
  state.buyingPowerMicroraster = (await API.getBuyingPowerMicroraster(layer)).data;
  state.competitors = (await API.getCompetitors(layer, (specialty !== 'Alle' ? specialty : null))).data;
  state.microraster = (await API.getMicroraster(layer)).data;

  if (state.activeLayer) {
    dispatch('map/centerOn', state.activeLayer.getSource(), {root: true});
  }

  dispatch('common/loader/stop', null, {root: true});
};

// @ts-ignore
export const createReport = async ({state, dispatch, rootState}, layer) => {
  dispatch('common/loader/start', null, {root: true});
  await dispatch('map/centerOn', state.activeLayer.getSource(), {root: true});
  await dispatch('map/createScreenshot', null, {root: true});

  // TODO: fix this
  // dirty workaround: timeout till image is taken
  setTimeout(async () => {
    const res = await API.createReport(layer, rootState.map.img, rootState.doctors.hauptfach);
    const blob = new Blob([res.data], {type: 'application/pdf;charset=utf-8'});
    saveAs(
      blob,
      layer
        .replace(/\s+/g, '_')
        .replace(/[^A-Za-z0-9\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df]/g, '') + '.pdf',
    );
    dispatch('common/loader/stop', null, {root: true});
  }, 2000);
};

// @ts-ignore
export const deleteCatchment = async ({state, dispatch, rootState}, layer) => {
  dispatch('common/loader/start', null, {root: true});
  await API.deleteCatchment(layer);
  dispatch('read');

  dispatch('common/loader/stop', null, {root: true});
};

// @ts-ignore
export const geocode = async ({state, dispatch}, address) => {
  try {
    const ret = await API.geocode(address);

    if (ret && ret.data && ret.data.resourceSets && ret.data.resourceSets[0] && ret.data.resourceSets[0].resources) {
      state.addresses = ret.data.resourceSets[0].resources;
    }
  } catch (err) {
    dispatch('common/snackbar/error', err, {root: true});
  }
};

// @ts-ignore
export const getArea = async ({state, dispatch}, coords) => {
  try {
    return await API.getArea(coords);
  } catch (err) {
    dispatch('common/snackbar/error', err, {root: true});
  }
};

// @ts-ignore
export const calculateCatchment = async ({commit, dispatch, state}, options) => {
  try {
    dispatch('common/loader/start', null, {root: true});
    const catchment = await API.postCatchment(options);

    dispatch('getStatistics', catchment.data.features[0].properties.name);
    dispatch('read');

    dispatch('common/loader/stop', null, {root: true});
    return true;
  } catch (err) {
    dispatch('common/loader/stop', null, {root: true});
    dispatch('common/snackbar/error', err, {root: true});
    return false;
  }
};

// @ts-ignore
export const calculateQuickCatchment = async ({commit, dispatch, rootState}, {coordinate, name}) => {
  try {
    dispatch('common/loader/start', null, {root: true});
    if (rootState.auth.anonymous) {
      dispatch('setInfoDialog', true);
    }

    commit('setQuickCatchment', false);
    // Step 1: get zone
    // https://smartmap.at/api/locations?x=1562143.547064147&y=6133460.023659113
    let zone = await API.getArea({
      x: coordinate[0],
      y: coordinate[1],
    });
    zone = zone.data.lage;

    const options = {
      x: coordinate[0],
      y: coordinate[1],
      networkKind: 'pedes',
      networkUnit: 'meter',
      limits: [500, 1000, 2000],
      address: name,
    };

    // @ts-ignore
    if (zone === 3) {
      options.limits = [600, 1200, 1800];
      options.networkKind = 'car';
      options.networkUnit = 'sec';

      // @ts-ignore
    } else if (zone === 2) {
      options.limits = [300, 600, 1200];
      options.networkKind = 'car';
      options.networkUnit = 'sec';
    }

    const catchment = await API.postCatchment(options);

    dispatch('read');
    dispatch('getStatistics', catchment.data.features[0].properties.name);

    dispatch('common/loader/stop', null, {root: true});
    return true;
  } catch (ex) {
    dispatch('common/loader/stop', null, {root: true});
    dispatch('common/snackbar/error', ex, {root: true});
    return false;
  }
};


// @ts-ignore
export const startQuickCatchment = async ({commit, dispatch}) => {
  try {
    commit('setQuickCatchment', true);
    return true;
  } catch (ex) {
    dispatch('common/snackbar/error', ex, {root: true});
    return false;
  }
};

// @ts-ignore
export const stopQuickCatchment = async ({commit, dispatch}) => {
  try {
    commit('setQuickCatchment', false);
    return true;
  } catch (ex) {
    dispatch('common/snackbar/error', ex, {root: true});
    return false;
  }
};

// @ts-ignore
export const setInfoDialog = async ({commit, dispatch}, val) => {
  try {
    commit('setInfoDialog', val);
    return true;
  } catch (ex) {
    dispatch('common/snackbar/error', ex, {root: true});
    return false;
  }
};

// @ts-ignore
export const setWelcomeDialog = async ({commit, dispatch}, val) => {
  try {
    commit('setWelcomeDialog', val);
    return true;
  } catch (ex) {
    dispatch('common/snackbar/error', ex, {root: true});
    return false;
  }
};
